export const removeTextAlignmentFromDraftJs = (text: string) => {
    return text
        .replaceAll("text-align: left;", "")
        .replaceAll("text-align: right;", "")
        .replaceAll("text-align: center;", "")
        .replaceAll("text-align:left;", "")
        .replaceAll("text-align:right;", "")
        .replaceAll("text-align:center;", "");
};
